import React, { FC } from 'react';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

interface Props {
  href: string;
  text: string;
}

const useStyles = makeStyles(theme => ({
  button: {
    minWidth: 100,
    backgroundColor: theme.custom.palette.whiteAlternate,
    '&:hover': {
      backgroundColor: theme.custom.palette.whiteAlternate2,
    },
  },
}));

const ActionButton: FC<Props> = ({ href, text }) => {
  const classes = useStyles();

  return (
    <Button href={href} target="_blank" className={classes.button} fullWidth>
      {text}
    </Button>
  );
};

export default ActionButton;
